"use strict";

import React, { Component, PropTypes } from 'react';
import { Modal, Button } from 'react-bootstrap';

import AnswerActions from '../../../actions/AnswerActions';
import AnswerStore from '../../../stores/AnswerStore';
import AnswerPopupForm from './AnswerForm';

class AnswerPopup extends Component {

  constructor() {
    super();
    this.state = {
      canAnsSubmit: false,
    };

    this._onAnsFormValid = this._onAnsFormValid.bind(this);
    this._handleAnsSubmit = this._handleAnsSubmit.bind(this);
    this._handleAnswerStore = this._handleAnswerStore.bind(this);
  };

  static propTypes = {
    open: PropTypes.bool.isRequired,

  };

  componentWillMount(){
     AnswerStore.listen(this._handleAnswerStore);
    // this.setState ({
    //   question: AnswerStore.getQuestionIdForAnswerPopupPublic()
    // })
  }

  componentWillUnmount(){
    AnswerStore.unlisten(this._handleAnswerStore);
  }

  render() {
    return(
      <Modal show={this.props.open} onHide={AnswerPopup._handleCloseAnswerPopup}>
        <Modal.Header closeButton>
          <Modal.Title>Answer a Question</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AnswerPopupForm ref={ i => this.ansForm = i }
                           isValid={this._onAnsFormValid}
                           editAnswerPopup={this.state.editAnswerPopup} />
        <div>
          <Button bsStyle="success"
                  disabled={!this.state.canAnsSubmit}
                  onClick={this._handleAnsSubmit} >Submit</Button>
          <Button className="m-l-5p" type="button"
                  bsStyle="default"
                  onClick={AnswerPopup._handleCloseAnswerPopup}>Cancel</Button></div>
          </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    )
  };

  _onAnsFormValid(isValid) {
    this.setState({ canAnsSubmit: isValid });
  };

  _handleAnsSubmit(e) {
    e.preventDefault();

    let answer = this.ansForm.getModel();

    this.state.editAnswerPopup && this.state.editAnswerPopup._id
      ? answer._id = this.state.editAnswerPopup._id: '';
    this.state.answerPopupQuestionId
      ? answer.question = this.state.answerPopupQuestionId: null;

    const  location = window.location.pathname;
    let aType = "", idx=0;
    if(location.indexOf('question-feed') > -1){
      aType=JSON.stringify({"qFeed":1});
    } else if(location.indexOf('question/') > -1){
      idx = location.indexOf('question/');
      let qId = location.substring(idx+9);
      qId = (qId.indexOf('/')>-1 ? qId.substring(qId.indexOf('/')+1) : qId);
      aType = JSON.stringify({"qId":qId})
    } else if(location.indexOf('q/') > -1){
      idx = location.indexOf('q/');
      let cId = location.substring(idx+13);
      cId = (cId.indexOf('/')>-1 ? cId.substring(cId.indexOf('/')+1) : cId);
      aType = JSON.stringify({"q4Conf":{"_id":cId}})
    }
    answer.fromPage = aType;

    AnswerActions.create(answer);
  };

  static _handleCloseAnswerPopup() {
    AnswerActions.closeAnswerPopup();
  };

  _handleAnswerStore(state){
    this.setState({
      answerPopupQuestionId: state.answerPopupQuestionId,
      editAnswerPopup: state.editAnswerPopup,
    });
  }
}

export default AnswerPopup;
